import PropTypes from 'prop-types'
import Family from './family'

export default PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  code: PropTypes.string.isRequired,
  item_description: PropTypes.string.isRequired,
  hierarchy: PropTypes.string.isRequired,
  families: PropTypes.arrayOf(Family),
  all_families_selected: PropTypes.bool
})
